import {Link, useParams} from "react-router-dom";

import "../sass/components/processing.scss"
import {useDispatch} from "react-redux";
import {ReactSession} from "react-client-session";
import {fetchCustomer, fetchPaymentVintner, fetchOneOrderEmail, fetchConfirmOrder, fetchOrderData} from "../apiRequests/api";
import {useAuth0} from "@auth0/auth0-react";
import { React, useContext, useEffect, useState } from 'react';
import {SigninContext} from "../contexts/SigninContext";
import Loading from "./Loading";
import BasketListCheckout from "./BasketListCheckout";
import { NumericFormat } from 'react-number-format';

export default function ProcessingOrder() {
    const {orderId} = useParams()
    const {backOrderId} = useParams()
    const {reservesOrderId} = useParams()
    const [confirmedOrderId, setConfirmedOrderId] = useState(orderId)
    const [confirmedBackOrderId, setConfirmedBackOrderId] = useState(backOrderId)
    const [confirmedReservesOrderId, setConfirmedReservesOrderId] = useState(reservesOrderId)
    const [orderStatus, setOrderStatus] = useState("Processing")
    const [backOrderStatus, setBackOrderStatus] = useState("Processing")
    const [reservesOrderStatus, setReservesOrderStatus] = useState("Processing")
    const {getIdTokenClaims} = useAuth0()
    const {userName} = useContext(SigninContext)
    const [isLoading, setIsLoading] = useState(false)
    const [confirmed, setConfirmed] = useState(false)
    const [customerData, setCustomerData] = useState(null)
    const [orderData, setOrderData] = useState(null)

    async function confirmOrder() {
        if (orderId && orderId !== '0' && sessionStorage.getItem(orderId) !== '1') {
            const token = await getIdTokenClaims()
            if (orderId.startsWith("XX")) {
                const order = await fetchConfirmOrder(orderId, userName, token.__raw)
                if (order.mainResult) {
                    setConfirmedOrderId(order.mainResult)
                    setOrderStatus('Confirmed')

                }
            }
        }
        if (backOrderId && backOrderId !== '0' && sessionStorage.getItem(backOrderId) !== '1') {
            const token = await getIdTokenClaims()
            if (backOrderId.startsWith("XX")) {
                const backOrder = await fetchConfirmOrder(backOrderId, userName, token.__raw)
                if (backOrder.mainResult) {
                    setConfirmedBackOrderId(backOrder.mainResult)
                    setBackOrderStatus('Confirmed')

                }
            }
        }
            if (reservesOrderId && reservesOrderId !== '0' && sessionStorage.getItem(reservesOrderId) !== '1') {
                const token = await getIdTokenClaims()
                if (reservesOrderId.startsWith("XX")) {
                    const reservesOrder = await fetchConfirmOrder(reservesOrderId, userName, token.__raw)
                    if (reservesOrder.mainResult) {
                        setConfirmedReservesOrderId(reservesOrder.mainResult)
                        setReservesOrderStatus('Confirmed')
                    }
                }


            }
            setConfirmed(true)
        }

   async function getConfirmationInfo() {
     let orders = [];
     if (orderId && orderId !== '0') {
       orders.push(orderId);
     }
     if (backOrderId && backOrderId !== '0') {
       orders.push(backOrderId);
     }
     if (reservesOrderId && reservesOrderId !== '0') {
       orders.push(reservesOrderId);
     }

     // Fetch customer data
     const token = await getIdTokenClaims();
     const customerResponse = await fetchCustomer({ CustomerAccount: userName }, token.__raw);
     if (!customerResponse.error) {
       setCustomerData(customerResponse);
     }

     // Fetch order data
     if (orders.length > 0) {
       try {
         const orderResponse = await fetchOrderData({
           orders: orders,
         }, token.__raw);
         if (!orderResponse.error) {
           setOrderData(orderResponse);
         }
       } catch (error) {
         setOrderData([]);
       }
     }
     else {
       setOrderData([]);
     }
   }

   function dateToPretty(dateStr) {
     const [day, month, year] = dateStr.split('/').map(Number);
     const date = new Date(year, month - 1, day);

     const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });

     return `${weekday} ${day}/${month}/${year}`;
   }

    async function sendOrderEmail(orderID,hasBackOrder) {
        const token = await getIdTokenClaims()
        await fetchOneOrderEmail(orderID, userName, token.__raw, 'Order')
        sessionStorage.setItem(orderId, '1');
    }
    async function sendBackOrderEmail(orderID, hasBackOrder) {
        const token = await getIdTokenClaims();
        await fetchOneOrderEmail(orderID, userName, token.__raw, 'Back Order');
        sessionStorage.setItem(backOrderId, '1');
    }
    async function sendReservesOrderEmail(orderID, hasBackOrder) {
        const token = await getIdTokenClaims();
        await fetchOneOrderEmail(orderID, userName, token.__raw, 'Reserves Order');
        sessionStorage.setItem(reservesOrderId, '1');
    }

    useEffect(() => {
            confirmOrder()
            getConfirmationInfo()
    }, [])
    useEffect(() => {
        if (orderStatus === 'Confirmed' && sessionStorage.getItem(orderId) !== '1') {
            sendOrderEmail(confirmedOrderId)
        }
        if (backOrderStatus === 'Confirmed' && sessionStorage.getItem(backOrderId) !== '1') {
            sendBackOrderEmail(confirmedBackOrderId)
        }
        if (reservesOrderStatus === 'Confirmed' && sessionStorage.getItem(reservesOrderId) !== '1') {
            sendReservesOrderEmail(confirmedReservesOrderId)
        }
    }, [confirmed])



    return (
        <div className="page processing-page">

          <div className="title">
            <p>Thank you. {orderStatus === 'Confirmed' ?
              <>We are getting {orderId.length > 1 ? `order number ${confirmedOrderId}`  : 'your order'} ready for you.</> :
              <>Your {orderId.length > 1 ? `order number ${confirmedOrderId}`  : 'order'} was confirmed!</>}
            </p>
            {orderId.length === 1 && backOrderId.length === 1 && reservesOrderId.length > 1 &&
              <p>All items have been moved to Reserves Order: {confirmedReservesOrderId}</p>
            }
            {((orderId.length > 1 || backOrderId.length > 1) && reservesOrderId.length > 1) ? (
                <p>Some items have been moved to Reserves Order: {confirmedReservesOrderId}</p>
              ):
              <></>
            }
            {orderId.length > 1 && backOrderId.length > 1 &&
              <p>Not all Stock available. Some items have been moved to an additional Back Order: {confirmedBackOrderId}</p>
            }
            {orderId.length === 1 && backOrderId.length > 1 && reservesOrderId.length > 1 &&
              <p>Not all Stock available. Some items have been moved to Back Order: {confirmedBackOrderId}</p>
            }
            {orderId.length === 1 && backOrderId.length > 1 && reservesOrderId.length === 1 &&
              <p>No Stock. All items have been moved to Back Order: {confirmedBackOrderId}</p>
            }
          </div>
          <div className="subtitle">
            To view this and past orders, please go to <a href="/orders">My Orders</a>.
          </div>

          {orderData === null ? (
            <Loading />
          ) : (
            <>
              {customerData && (
                <div className="account-balance">
                  <strong>New Account Balance</strong> {!customerData ? 'loading...' :
                    <div className={"value"}><NumericFormat customer="customer"
                                        value={Number(customerData.CreditBalance).toFixed(2)}
                                        displayType={'text'} thousandSeparator={true}
                                        prefix={window.currency}/></div>
                  }
                </div>
              )}
              <div className="order-details-container">
                <div className="order-details-left">
                  {orderData && orderData.delivery && (
                    <div className="delivery-info">
                      <h3>Delivery Address</h3>
                      <strong>{orderData.delivery.CustomerAccount}</strong>
                      {orderData.delivery.Delivery_Name && <p>{orderData.delivery.CustomerAccount === 'Collection' ? <i className="fas fa-icon fa-location-dot"></i> : <i className="fas fa-icon fa-user"></i>}{orderData.delivery.Delivery_Name}</p>}
                      {orderData.delivery.Delivery_Address1 && <p>{orderData.delivery.CustomerAccount === 'Collection' ? '' : <i className="fas fa-icon fa-location-dot"></i>}{orderData.delivery.Delivery_Address1}</p>}
                      {orderData.delivery.Delivery_Address2 && <p>{orderData.delivery.Delivery_Address2}</p>}
                      {orderData.delivery.Delivery_Address3 && <p>{orderData.delivery.Delivery_Address3}</p>}
                      {orderData.delivery.Delivery_Address4 && <p>{orderData.delivery.Delivery_Address4}</p>}
                      {orderData.delivery.Delivery_PostCode && <p>{orderData.delivery.Delivery_PostCode}</p>}
                    </div>
                  )}
                </div>

                <div className="order-details-right">
                    {process.env.REACT_APP_DELIVERY_DATES == '1' && orderData?.delivery?.RequiredDate && (
                        <div className="requested-delivery-date">
                            <p className="section-title">Requested Delivery Date</p>
                            <p className="value">{dateToPretty(orderData.delivery.RequiredDate)}</p>
                        </div>
                    )}

                  <div className="order-details-inner-right">
                    {orderData && orderData.items && (
                      <div className="order-items">
                        <h3>Order summary</h3>
                        <BasketListCheckout cartItems={orderData.items} />
                      </div>
                    )}

                    {orderData?.delivery?.CustomerReference && (
                      <div className="customer-reference">
                        <p className="section-title">Customer Reference / Purchase Order</p> <p className="value">{orderData.delivery.CustomerReference}</p>
                      </div>
                    )}

                    {orderData?.delivery?.Delivery_Notes && orderData.delivery?.Delivery_Notes.length > 0 && (
                      <div className="delivery-notes">
                        <h3>Delivery Notes:</h3>
                        <p>{orderData.delivery?.Delivery_Notes}</p>
                      </div>
                    )}

                    <div className="contact-section">
                      <h3>Contact Us</h3>
                      <div className="contact-links">
                        <Link to={`tel:${process.env.REACT_APP_PHONE}`}><i className="fas fa-icon fa-phone"></i>{process.env.REACT_APP_PHONE}</Link>
                        <Link to={`mailto:${process.env.REACT_APP_EMAIL}`}><i className="fas fa-icon fa-envelope"></i>{process.env.REACT_APP_EMAIL}</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
    )
}
